window.Vue = require('vue');

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

Vue.component('formulario-contacto-freemium', require('../../componentes/sitio/FormularioContactoFreemiumProyecto').default);

Vue.config.productionTip = false;
Vue.config.devtools = false;

if(document.getElementById("vue-contacto-freemium")){
    const contacto = new Vue({
        el: '#vue-contacto-freemium',
    });
}
